import { render, staticRenderFns } from "./page401.vue?vue&type=template&id=0f84e8b6&scoped=true&"
import script from "./page401.vue?vue&type=script&lang=ts&"
export * from "./page401.vue?vue&type=script&lang=ts&"
import style0 from "./page401.vue?vue&type=style&index=0&id=0f84e8b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f84e8b6",
  null
  
)

export default component.exports